<h3 mat-dialog-title >
    <b>Indicação</b> 
</h3>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Nome</mat-label>
        <input 
            matInput 
            placeholder="Nome"
            aria-label="Nome" 
            [formControl]="nome" 
            required
            maxlength="255">
    </mat-form-field>
</div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Telefone</mat-label>
        <input matInput placeholder="Telefone" [formControl]="telefone" required name="telefone" mask="(00) 00000-0000">
    </mat-form-field>
</div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="49" >
        <mat-label>Valor Potencial de Captação</mat-label>
        <input 
            matInput 
            placeholder="Valor Potencial de Captação" 
            [formControl]="valor_pl" 
            currencyMask 
            [options]="{  suffix: ' ', prefix: 'R$ ', thousands: '.', decimal: ',' }">
    </mat-form-field>
</div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Observação</mat-label>
        <textarea matInput name="observacao" [formControl]="observacao" rows="5"></textarea>
    </mat-form-field>
</div>
 <div mat-dialog-actions style="text-align: center; margin-top: 20px;">
     <button 
         mat-button 
         tabindex="2" 
         (click)="onNoClick()">
         Cancelar
     </button>
     <button 
         mat-button 
         [disabled]="isInvalidForm()" 
         (click)="salvar()" 
         tabindex="-1">
         Confirmar
     </button>
 </div>